import React, { StrictMode, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { post } from '../../utils/axios';
import AlertMsg from './AlertMsg';

function QuickContact({ upcomingMock, board }) {
    let [enquiryDetails, setEnquiryDetails] = useState({});

    const onChange = (e) => {
        setEnquiryDetails((preState) => {
            return { ...preState, [e.target.name]: e.target.value }
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();
        let data = enquiryDetails;
        post(`/enquiry`, data)
            .then((res) => {
                if (res.success) {
                    AlertMsg("success", "Saved successfully.")
                    setEnquiryDetails({
                        email: "",
                        mobile_number: "",
                        name: "",
                        query: ""
                    });
                }
            })
    }

    const showIncomingAlert = () => {
        Swal.fire(
            {
                title: 'Launching Soon. Stay tuned!!',
                icon: 'info'
            }
        )
    }

    return (
        <StrictMode>
            <footer id="footer" className="wow fadeInUp">
                <div className="container">

                    <div className="footerContainer">
                        <div className="leftfooter wow fadeInUp ">

                            <div className="ftrlink wow fadeInUp">
                                <h3>Important Links</h3>
                                <ul>
                                    <li><Link to="#">Contact Us </Link></li>
                                    <li><Link to="/testimonial">Testimonial </Link></li>
                                    {/*<li><Link to="#">Enquiry</Link></li>*/}

                                    <li><Link to="/why-our-mocks" >Why Our Mocks?</Link></li>
                                    <li><Link to="/about-us" >About us</Link></li>
                                    <li><Link to="/faq" >FAQ's </Link></li>
                                    <li><Link to="/terms-and-conditions" >Terms & conditions</Link></li>
                                </ul>
                            </div>

                            <div className="ftrlink wow fadeInUp">
                                <h3>Services</h3>
                                <ul>
                                    <li><a href onClick={showIncomingAlert} >Tuition</a></li>
                                    <li><Link to="/mock-exam">Mock Exams </Link></li>
                                    <li><Link to="/practice-paper">Practice Papers</Link></li>
                                    <li><Link to="/past-paper">Past Papers</Link></li>
                                </ul>
                            </div>

                            {/*<div className="ftrlink wow fadeInUp">
                                                            <h3>Featured Mock Exams</h3>
                                                            <ul>
                                                                {upcomingMock && upcomingMock.length>0 && upcomingMock.map((item, index) => {
                                                                  return (item && <li key={index}><Link to={`/book-exam-details`} state={{ exam: item,status:'online' }} >{item.name} </Link></li>)
                                                                })}                             
                                                            </ul>
                                                        </div>
                            
                                                        <div className="ftrlink wow fadeInUp">
                                                            <h3>Exam Test Paper</h3>
                                                            <ul>
                                                                {board && board.length>0 && board.map((item, index) => {
                                                                  return <li key={index}><Link to="/book-exam-online" state={{ selected: item._id, status: 'online' }} >{item.name} </Link></li>
                                                                })}
                                                            </ul>
                                                        </div>*/}

                        </div>
                        <div className="rightfooter wow fadeInUp">
                            <h3>Quick Contact</h3>
                            <form onSubmit={onSubmit} className="wow fadeInUp">
                                <div className="red-text-right">*All Entries are Mandatory</div>
                                <div className="form-group">
                                    <input type="text" placeholder="enter your name" name="name" value={enquiryDetails.name} onChange={onChange} required />
                                </div>
                                <div className="form-group">
                                    <input type="tel" placeholder="enter your mobile no." name="mobile_number" value={enquiryDetails.mobile_number} onChange={onChange} required minLength="10" maxLength="10" />
                                </div>
                                <div className="form-group">
                                    <input type="email" placeholder="enter your email id" name="email" value={enquiryDetails.email} onChange={onChange} required />
                                </div>
                                <div className="form-group">
                                    <textarea id="" cols="30" rows="10" placeholder="enter your message" name="query" value={enquiryDetails.query} onChange={onChange} required ></textarea>
                                </div>
                                <div className="form-group">
                                    <div className="mainCtablock"><button className="maincta"><span>SUBMIT</span><img
                                        src="/images/arrow.svg" alt="" /></button></div>
                                </div>
                            </form>

                            <div className="followusDiv wow fadeInUp">
                                <h3>Follow Us</h3>
                                <ul>
                                    <li><a href="https://www.facebook.com/11plusleader/" target="_blank"><img src="/images/facebook.png" alt="" /></a></li>
                                    <li><a href="https://www.linkedin.com/company/11plusleader/" target="_blank"><img src="/images/linkedin.png" alt="" /></a></li>
                                    <li><a href="https://instagram.com/11plusleader?utm_medium=copy_link" target="_blank"><img src="/images/instagram.png" alt="" /></a></li>
                                </ul>
                            </div>

                        </div>
                    </div>


                </div>
            </footer>
        </StrictMode>
    )
}

export default QuickContact;